import HTTP from './http-interceptor';
import { AUTH } from '../constants';

const AuthService = {
    
    login: async (email, password) => {
        const data = { 
            correo: email,
            contrasenia: password,
        };
        return HTTP.post(AUTH.LOGIN, data);
    },
    passwordRecovery: async (email) => {
        const data = { correo: email };
        return HTTP.post(AUTH.PASSWORD_RECOVERY, data);
    },
    setAvatar: async (player, form) => {
        return HTTP.post(`${AUTH.SET_AVATAR_V2}${player}`, form);
    },
    setPassword: async (player, currentPassword, newPassword) => {
        const data = {
            currentPassword, 
            newPassword
        }
        return HTTP.post(`${AUTH.SET_PASSWORD_V2}${player}`, data);
    },
}

export default AuthService;